import { HttpErrorResponse } from '@angular/common/http';
import { Input, ViewChildren, forwardRef } from '@angular/core';
import { ElementRef } from '@angular/core';
import { QueryList } from '@angular/core';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faRefresh, faSignIn, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { Organization } from '../../../shared/interfaces/entities/organization.interface';
import { SelectControl } from '../../../shared/ui/controls/select-control.model';
import { OrganizationLoginSelect } from '../../../shared/ui/select-controls/organization-login-select.model';
import { AuthenticationService } from '../../services/authentication.serivce';
import { SelectFieldComponent } from '../../../shared/components/select-field/select-field.component';

@Component({
    selector: 'app-admin-organization-login',
    templateUrl: './admin-organization-login.component.html',
    styleUrls: ['./admin-organization-login.component.css'],
    standalone: false
})
export class AdminOrganizationLoginComponent implements OnInit, OnDestroy, AfterViewInit {

  organizationSelect: OrganizationLoginSelect;
  loginForm: FormGroup;
  submitted: boolean = false;
  loginErrorMessage: string;

  signIn = faSignIn;

  showLoginScreen: boolean = false;

  refeshIcon: IconDefinition = faRefresh;

  @Input() entity: Organization;

  @ViewChildren("icon") public icons: QueryList<FaIconComponent>;
  @ViewChild("backgroundImage") public bgImage: ElementRef;


  get f() { return this.loginForm.controls; }

  constructor(private formBuilder: FormBuilder, private auth: AuthenticationService, private router: Router, private activatedRoute: ActivatedRoute) {
    var session = auth.getSession();
    this.organizationSelect = new OrganizationLoginSelect("Test", "", null);
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      organization: [OrganizationLoginSelect, Validators.required]
    });

    var drawer = document.getElementById("drawer") as HTMLDivElement;
    drawer.style.display = "none"; 
  }

  ngAfterViewInit() {
    var img = this.bgImage.nativeElement as HTMLImageElement;
    img.onload = () => { this.backgroundImageOnload(); }
    img.onerror = () => { this.bgError(); }
    img.src = "../../../../assets/images/epc4.jpg";
    if (img.complete) {
      this.showLoginScreen = true;
    }
  }

  backgroundImageOnload() {
    this.showLoginScreen = true;
  }

  bgError() {
    console.log("Error loading background image");
  }

  ngOnDestroy(): void {
    // Need to clean up our observable subscription to avoid memory leaks 
    this.auth.onDestroy();
  }

  adminOrganization(value: any) {

    this.refeshIcon = faRefresh;

    var iconContainer = document.getElementById('iconContainer');
    if (iconContainer) {
      iconContainer.classList.add('rotate');
    }

    this.submitted = true;

    var organizationId = this.organizationSelect.getValue();
    var organizationName = this.organizationSelect.getTextValue();

    if (organizationId != null && organizationName != null) {
      this.auth.setOrganization(Number(organizationId), organizationName);

      var baseUrl = window.location.href.replace(this.router.url, '');
      window.location.replace(baseUrl);

      this.onReset();
    }
  }

  onReset() {
    this.submitted = false;
    this.loginForm.reset();
  }

}
